import { render, staticRenderFns } from "./alunos-evadidos.vue?vue&type=template&id=0e766a86"
import script from "./alunos-evadidos.vue?vue&type=script&lang=js"
export * from "./alunos-evadidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports